module.exports = __webpack_public_path__ + "static/media/phone_suite_calling_party.4f5317b1.png";